import React, { useRef, useState } from "react";
import { Image, InputGroup, Button } from "react-bootstrap";
import FormControlSearchWithAPI from "../FormControlSearchWithAPI";
import {
  useDeepEffect,
  useDidClickedOutside,
  useRequest,
} from "../../abstracts";
import { get, isEmpty } from "lodash";
import { Loader } from "../LoaderWrapper";
import e from "cors";

const SearchDropdownWithAPI = ({
  handleSelect,
  placeholder,
  searchPayload,
  searchPayloadKey,
  isEmployeePage = false,
  method,
  labelKey,
  screen,
}) => {
  const popupDomRef = useRef(null);
  let searchChangeTimeout = null;
  let arr = [];
  const [searchText, setSearchText] = useState("");
  const [searchValueDisplayed, setSearchValueDisplayed] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const { response, loading } = useRequest({
    method,
    payload: {
      ...searchPayload,
      [searchPayloadKey]: searchText.trim(),
      from: 1,
      to: 100,
      showTerminated: true,
    },
    defaultResponse: [],
    triggerOnlyOnUpdate: true,
  });
  const apiResponse = isEmployeePage
    ? response.searchEmployeeResults
    : response;
  const listArray = () => {
    apiResponse?.map((item) => {
      const obj = labelKey.reduce(
        (acc, cur, idx) => ({ ...acc, [idx + 1]: item[cur] }),
        {}
      );
      const objectValue = Object.values(obj);
      arr.push(...objectValue);
      // eslint-disable-next-line jsx-a11y/anchor-is-valid
    });
    let secondArr = removeDuplicates(arr);
    return secondArr.filter((data) => data !== null);
  };
  const clickedOutside = useDidClickedOutside(popupDomRef);
  const className =
    screen === "plan-group-home"
      ? "form-control-seach-text plan-group-searchbar"
      : screen === "payroll-listing"
      ? "search-with-api-text-var"
      : "search-with-api-text";
  const size =
    screen === "plan-group-home" || screen === "payroll-listing" ? "xs" : "lg";
  useDeepEffect(() => {
    if (clickedOutside) {
      setIsPopupOpen(false);
    }
  }, [clickedOutside]);
  const handleSearchChange = (e) => {
    window.clearInterval(searchChangeTimeout);
    const val = e.target.value;
    setSearchValueDisplayed(val);
    if (val.length >= 0) {
      searchChangeTimeout = window.setTimeout(() => {
        setSearchText(val);
        setIsPopupOpen(true);
      }, 500);
    }
    if (val.length === 0) {
      handleSelect(val);
    }
  };
  function removeDuplicates(array) {
    return array.filter((item, index) => array.indexOf(item) === index);
  }
  const handleOptionSelect = (value) => {
    setSearchValueDisplayed(value);
    setIsPopupOpen(false);
    handleSelect(value.trim());
  };

  const onSearchClick = (e) => {
    e.preventDefault();
    handleSelect(searchValueDisplayed.trim());
  };

  return (
    <div className="search-dropdown-api" ref={popupDomRef}>
      <InputGroup>
        {screen === "payroll-listing" && (
          <InputGroup.Append>
            <Button
              variant="link"
              className="search-with-api-button-var h-100"
              onClick={onSearchClick}
            >
              <Image src="/assets/icons/svg/search.svg" />
            </Button>
          </InputGroup.Append>
        )}
        <FormControlSearchWithAPI
          size={size}
          type="search"
          placeholder={placeholder}
          onChange={handleSearchChange}
          onKeyPress={(e) => {
            e.key === "Enter" && onSearchClick(e);
          }}
          className={className}
          value={searchValueDisplayed}
          screen={screen}
        />
        {screen === "plan-group-home" && (
          <div className="search-icon">
            <InputGroup.Append>
              <i class="fal fa-search" aria-hidden="true"></i>
            </InputGroup.Append>
          </div>
        )}
        {screen !== "plan-group-home" && screen !== "payroll-listing" && (
          <InputGroup.Append style={{ height: "2.5rem" }}>
            <Button
              variant="link"
              className="search-with-api-button h-100"
              onClick={onSearchClick}
            >
              <Image src="/assets/icons/svg/search.svg" />
            </Button>
          </InputGroup.Append>
        )}
      </InputGroup>
      {isPopupOpen && !isEmpty(searchText) && (
        <div className="d-flex flex-column options-wrapper">
          {loading && (
            <div className="d-flex justify-content-center py-3">
              <Loader size="sm" />
            </div>
          )}
          {!loading &&
            listArray().map((data) => (
              <a
                // eslint-disable-next-line no-script-url
                href="javascript:void(0)"
                className="search-option-item"
                onClick={() => handleOptionSelect(data)}
              >
                {data}
              </a>
            ))}
        </div>
      )}
    </div>
  );
};

export default SearchDropdownWithAPI;
